import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const User = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M13.63 13.88H9.87A6.88 6.88 0 0 0 3 20.75c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25 0-3.8-3.08-6.88-6.88-6.88ZM4.9 20.12a5 5 0 0 1 4.96-4.37h3.76a5 5 0 0 1 4.96 4.38H4.9ZM11.75 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8.13a3.13 3.13 0 1 1 0 6.26 3.13 3.13 0 0 1 0-6.26Z"
    />
  </svg>
));
